import type { Auth0UserLike } from '../../types/auth0-user.type'

import { getProfileValue } from './getProfileValue'
import { isEmailLike } from './isEmailLike'

export const getFallbackFirstName = (auth0User: Auth0UserLike, email: string): string => {
  const nickname = getProfileValue(auth0User.profile?.nickname, auth0User.nickname)

  if (!nickname || isEmailLike(nickname)) {
    return email
  }

  return nickname
}
